import css from 'styled-jsx/css';

export default css`.sider-bar-item-box {
  margin-bottom: 51px;
  text-align: center;
  cursor: pointer;

  .item-icon-box {
    height: 30px;
  }

  .item-title-box {
    padding-top: 8px;
    font-size: 12px;
    line-height: 17px;
    color: #333;
    text-align: center;
  }
}
`